import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import CoursePopup from "../components/CoursePopup";

const Training = () => {
  const navigate = useNavigate();
  const [selectedCourse, setSelectedCourse] = useState(null);

  const courses = [
    {
      id: "engineering-survey",
      title: "Engineering Survey",
      description:
        "Learn advanced surveying techniques using industry-grade equipment such as Plane Table, Auto Level, Sprinter Level, and Total Station. Gain practical skills essential for land surveys in building and road construction projects, including creating survey drawings with AutoCAD.",
      importance:
        "In today’s fast-paced construction industry, precision is key. Mastering surveying ensures accuracy in planning and execution, reducing costly errors and ensuring the success of infrastructure projects.",
      equipment: [
        "Plane Table",
        "Auto Level",
        "Sprinter Level",
        "Total Station",
        "Leveling Staff",
      ],
      image: "/images/courses/engineering-survey.webp",
      images: [
        "/images/courses/engineering-survey1.jpg",
        "/images/courses/engineering-survey2.jpg",
      ],
    },
    {
      id: "non-destructive-test",
      title: "Non-Destructive Test (NDT)",
      description:
        "Master the techniques of Non-Destructive Testing to assess the quality of hardened concrete. Learn to use advanced tools for measuring crack depth, compressive strength, and structural uniformity without causing any damage.",
      importance:
        "Structural integrity is non-negotiable in today’s world of towering buildings and mega projects. NDT methods are indispensable for ensuring safety and compliance without affecting the structural elements.",
      equipment: ["Ultrasonic Pulse Velocity Meter", "Rebound Hammer"],
      image: "/images/courses/NDT.jfif",
      images: ["/images/courses/ndt1.jpg", "/images/courses/ndt2.jpg"],
    },
    {
      id: "quantity-estimation-and-costing",
      title: "Quantity Estimation and Costing",
      description:
        "Develop expertise in calculating quantities and preparing cost estimates for civil engineering projects. Gain knowledge of tender documents and manage resources efficiently using estimation tools.",
      importance:
        "Budget overruns are a major challenge in construction. Accurate estimation and costing are essential to managing resources, meeting deadlines, and staying competitive in the industry.",
      equipment: ["Measurement Tools", "Estimation Software"],
      image: "/images/courses/estimate.webp",
      images: ["/images/courses/estimate1.jpg", "/images/courses/estimate2.jpg"],
    },
    {
      id: "project-drafting-with-autocad",
      title: "Project Drafting with Auto-CAD",
      description:
        "Learn to create professional construction drawings using AutoCAD. This course covers contour maps, survey data integration, and working drawings for foundations, roofs, and utility installations.",
      importance:
        "Digital drafting is the backbone of modern construction. AutoCAD expertise allows you to produce precise, professional drawings that are critical for both design approval and execution.",
      equipment: ["AutoCAD Software", "Survey Data"],
      image: "/images/courses/autocad.jpg",
      images: ["/images/courses/autocad.jpg", "/images/courses/autocad.jpg"],
    },
    {
      id: "concept-of-site-engineering",
      title: "Concept of Site Engineering",
      description:
        "Understand the critical responsibilities of a site engineer, including material stacking, mobilization, and quality control. This course provides hands-on training in Earthwork, Brick Masonry, Scaffolding, and Shuttering.",
      importance:
        "Site engineers are the linchpins of any construction project. This course equips you with the leadership and technical skills required to manage on-site operations efficiently.",
      equipment: [
        "Material Testing Kits",
        "Scaffolding Components",
        "Shuttering Tools",
      ],
      image: "/images/courses/site engineering.avif",
      images: ["/images/courses/site1.jpg", "/images/courses/site2.jpg"],
    },
    {
      id: "sub-soil-exploration-and-testing",
      title: "Sub-Soil Exploration and Testing",
      description:
        "Learn soil investigation techniques such as Standard Penetration Tests and laboratory testing methods like Proctor’s Test and Triaxial Testing. Evaluate soil suitability for construction projects with precision.",
      importance:
        "Understanding soil properties is crucial to building safe and long-lasting structures. This course provides the knowledge needed to assess soil suitability for diverse projects, from high-rises to roadways.",
      equipment: [
        "Standard Penetration Test (SPT) Kit",
        "Triaxial Testing Equipment",
        "CBR Testing Kit",
        "Soil Permeability Testing Devices",
      ],
      image: "/images/courses/soil-exploration.webp",
      images: [
        "/images/courses/soil-exploration1.jpg",
        "/images/courses/soil-exploration2.jpg",
      ],
    },
    {
      id: "quality-control-and-material-testing",
      title: "Quality Control and Material Testing",
      description:
        "Master material testing procedures for bricks, cement, and aggregates. Learn compressive strength, water absorption, and sieve analysis techniques to ensure material quality meets industry standards.",
      importance:
        "Quality control ensures that construction materials meet safety and durability standards. This course empowers you to maintain high-quality work in any project you undertake.",
      equipment: [
        "Compression Testing Machine",
        "Water Absorption Testing Equipment",
        "Sieves for Aggregate Analysis",
      ],
      image: "/images/courses/quality-control.png",
      images: [
        "/images/courses/quality-control1.jpg",
        "/images/courses/quality-control2.jpg",
      ],
    },
    {
      id: "latest-technology-of-geo-tagging",
      title: "Latest Technology of Geo-Tagging",
      description:
        "Explore geo-tagging techniques to capture spatial data for engineering projects. Learn to use GPS devices and GIS software to monitor and manage large-scale infrastructure projects.",
      importance:
        "With the rise of smart cities and digital infrastructure, geo-tagging has become an essential skill for tracking and managing assets. This course prepares you for the future of data-driven engineering.",
      equipment: ["GPS Devices", "GIS Software"],
      image: "/images/courses/geo-tagging.jpg",
      images: [
        "/images/courses/geo-tagging1.jpg",
        "/images/courses/geo-tagging2.jpg",
      ],
    },
  ];

  useEffect(() => {
    AOS.init({ duration: 600, easing: "ease-in-out", once: true });
  }, []);

  const openPopup = (course) => {
    setSelectedCourse(course);
  };

  const closePopup = () => {
    setSelectedCourse(null);
  };

  return (
    <div className="container py-5" style={{margin:"auto"}}>
      {/* Top Section */}
      <div className="mb-5" style={{alignContent:"center"}} data-aos="fade-up">
        <h1 className="text-center heading" >Vocational Training</h1>
         <center> <p style={{textIndent:"100px", textAlign:"justify"}}>We proudly offer a comprehensive 40-day training program that encompasses all the courses listed below, carefully designed to provide hands-on experience and industry-relevant skills. With over a decade of expertise in vocational training, The Civil Lab has successfully shaped the careers of thousands of students, many of whom are now excelling in the construction and infrastructure industries.
            </p>
            <p style={{ textAlign:"justify"}}>Our program attracts learners from across India, including states such as Bihar, Kolkata, Madhya Pradesh, and beyond. This diversity creates a dynamic learning environment, fostering the exchange of ideas and experiences among students. Our commitment to delivering high-quality training has made us a preferred destination for those seeking practical, career-oriented education in civil engineering.
            </p>
            <a
            href="/files/vocational-training-topics.pdf" // Replace with the actual path to your PDF file
            download="vocational-training-topics.pdf" // Sets the default file name for the download
            className="btn-primary"
            style={{ textDecoration: "none", display: "inline-block" }}
          >
            <i className="fa-solid fa-file-pdf me-2" style={{ fontSize: "18px" }}></i>
            Download Training Syllabus
          </a>
          </center>
      </div>

      {/* Courses Section */}
      {courses.map((course, index) => (
        <div
          id={course.id}
          className={`row align-items-center mb-5 ${
            index % 2 === 0 ? "" : "flex-row-reverse"
          }`}
          key={course.id}
          data-aos="fade-up"
          style={{marginBottom: "40px"}}
        >
          <div className="col-md-6 text-center zoom-container">
            <img
              src={course.image}
              alt={course.title}
              className="img-fluid rounded shadow-sm zoom-image"
            />
          </div>
          <div className="col-md-6">
            <h2 className="mb-3">{course.title}</h2>
            <p className="text-muted">{course.importance}</p>
            <p>{course.description}</p>
            <h5>You’ll learn to use:</h5>
            <ul>
              {course.equipment.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <div className="text-center mt-4">
              <button
                className="btn btn-primary me-2"
                onClick={() =>
                  navigate(
                    `/contact?enquiryType=student-enrollment&course=${course.title}`
                  )
                }
              >
                Enroll Now <i class="fa-solid fa-right-to-bracket mw-2"></i>
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => openPopup(course)}
              >
                Details <i class="fa-solid fa-circle-info"></i>
              </button>
            </div>
          </div>
          <div style={{backgroundColor:"#ffe607", height:"6px", width:"100%", marginTop:"50px", marginBottom:"50px"}} data-aos="fade-up"></div>
        </div>
      ))}

      {/* Popup Window */}
      {selectedCourse && (
        <CoursePopup
          course={selectedCourse}
          onClose={closePopup}
        />
      )}
    </div>
  );
};

export default Training;
